import { FC, ReactNode } from 'react';
import styles from './SnoozeBody.module.scss';

type SnoozeBodyProps = {
  children: ReactNode;
};
const SnoozeBody: FC<SnoozeBodyProps> = ({ children }) => (
  <div className={styles.root}>
    {children}
  </div>
);

export default SnoozeBody;
